import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/WomensHealth/WomensHealthStep.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// WOMEN'S HEALTH STEP
// Reuses the --c-*/--sp-*/--r-sm/--t-fast custom properties that
// AssessmentStepShell.styles.js's <Section> scopes over the whole step —
// this file never redeclares them, same as MealScheduleStep.styles.js.
// Condition chip selected-state matches GoalCard/WorkTypeCard: 2.4px
// DIET_C.primary border, no fill.
// ═══════════════════════════════════════════════════════════════════════════════

export const FieldGroup = styled.div`
  margin-bottom: var(--sp-6);
`;
FieldGroup.displayName = "FieldGroup";

export const FieldLabel = styled.label`
  display: block;
  color: var(--c-text);
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: var(--sp-2);
`;
FieldLabel.displayName = "FieldLabel";

export const RequiredMark = styled.span`
  color: ${DIET_C.accent};
  margin-left: 2px;
`;
RequiredMark.displayName = "RequiredMark";

export const ErrorText = styled.p`
  color: ${DIET_C.accent};
  font-size: 0.8rem;
  font-weight: 600;
  margin: var(--sp-1) 0 0;
`;
ErrorText.displayName = "ErrorText";

// ─── Condition chips (Pregnant / Breastfeeding / PCOS / Menopause / None) ──
export const ConditionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--sp-3);

  @media (max-width: 40em) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
ConditionGrid.displayName = "ConditionGrid";

export const ConditionCard = styled.button`
  min-height: 56px;
  padding: var(--sp-3) var(--sp-2);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: ${({ $active }) => ($active ? DIET_C.primary : "var(--c-text)")};
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: 2.4px solid ${({ $active }) => ($active ? DIET_C.primary : `${DIET_C.secondary}66`)};
  transition: border-color var(--t-fast), color var(--t-fast);

  &:hover {
    border-color: ${DIET_C.primary};
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent);
    outline-offset: 2px;
  }
`;
ConditionCard.displayName = "ConditionCard";

// ─── Conditional pregnancy fields ───────────────────────────────────────────
export const PregnancyPanel = styled.div`
  margin-top: var(--sp-5);
  padding: var(--sp-4) var(--sp-5);
  border-radius: var(--r-sm);
  background: ${DIET_C.secondary}0f;
  border: 1px solid ${DIET_C.secondary}55;
`;
PregnancyPanel.displayName = "PregnancyPanel";

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-4);
  margin-bottom: var(--sp-5);

  @media (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;
FieldRow.displayName = "FieldRow";

const controlBase = `
  width: 100%;
  height: 44px;
  padding: 0 var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  transition: border-color var(--t-fast);
`;

export const Select = styled.select`
  ${controlBase}
  border: 1px solid ${({ $error }) => ($error ? DIET_C.accent : `${DIET_C.secondary}88`)};

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
Select.displayName = "Select";

export const DateInput = styled.input.attrs({ type: "date" })`
  ${controlBase}
  border: 1px solid ${DIET_C.secondary}88;

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
DateInput.displayName = "DateInput";

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 72px;
  padding: var(--sp-3);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: var(--c-text);
  font-size: 0.92rem;
  font-family: inherit;
  resize: vertical;
  border: 1px solid ${DIET_C.secondary}88;
  transition: border-color var(--t-fast);

  &:focus-visible {
    outline: none;
    border-color: ${DIET_C.primary};
  }
`;
TextArea.displayName = "TextArea";

export const ToggleRow = styled.div`
  display: flex;
  gap: var(--sp-2);
`;
ToggleRow.displayName = "ToggleRow";

export const ToggleButton = styled.button`
  flex: 1;
  padding: var(--sp-3) var(--sp-2);
  border-radius: var(--r-sm);
  background: var(--c-surface);
  color: ${({ $active }) => ($active ? DIET_C.primary : "var(--c-text)")};
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  border: 2.4px solid ${({ $active }) => ($active ? DIET_C.primary : `${DIET_C.secondary}66`)};
  transition: border-color var(--t-fast);

  &:hover {
    border-color: ${DIET_C.primary};
  }
`;
ToggleButton.displayName = "ToggleButton";
